module.exports = __webpack_public_path__ + "img/exam_jan_2025_d6mkjmg8.71081297.jpg";